import React from 'react';
import { func, object } from 'prop-types';
import { translate } from 'react-i18next';

import OutlineInput from '@dragonfruit/components/fields/OutlineInput';
import Checkbox from '@dragonfruit/components/fields/Checkbox';

import styles from './Company.scss';

function Company({ initialValues, t, onFieldChange, errors }) {
  const {
    companyEmail,
    guiNumber,
    companyName,
    companyEmailSameAsAccountEmail,
  } = initialValues;

  return (
    <React.Fragment>
      <div className={styles.email}>
        <OutlineInput
          id="companyEmail"
          label={t('purchase.tweinvoice.email')}
          value={companyEmail}
          onChange={value => onFieldChange('companyEmail', value)}
          disabled={companyEmailSameAsAccountEmail}
          error={errors.companyEmail}
        />
        <Checkbox
          label={t('purchase.tweinvoice.emailSame')}
          checked={companyEmailSameAsAccountEmail}
          onChange={value =>
            onFieldChange('companyEmailSameAsAccountEmail', value)
          }
        />
      </div>
      <div className={styles.row}>
        <OutlineInput
          className={styles.field}
          id="guiNumber"
          label={t('purchase.tweinvoice.triplicate.businessID')}
          value={guiNumber}
          onChange={value => onFieldChange('guiNumber', value)}
          error={errors.guiNumber}
        />
        <OutlineInput
          className={styles.field}
          id="companyName"
          label={t('purchase.tweinvoice.triplicate.companyName')}
          value={companyName}
          onChange={value => onFieldChange('companyName', value)}
          error={errors.companyName}
        />
      </div>
    </React.Fragment>
  );
}

Company.propTypes = {
  errors: object.isRequired,
  initialValues: object.isRequired,
  t: func.isRequired,
  onFieldChange: func.isRequired,
};

export default translate(['purchase'])(Company);



// WEBPACK FOOTER //
// ./app/components/EInvoiceSelector/components/Company/Company.jsx